import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../api/client";

export const fetchCurrentSubscription = createAsyncThunk(
  "billing/fetchCurrentSubscription",
  async (_, thunkApi) => {
    const res = await apiRequest("api/billing/subscription", { method: "GET" });

    if (!res.ok) {
      const errors = Array.isArray(res.data?.errors) ? res.data.errors : null;
      return thunkApi.rejectWithValue(
        errors?.join("\n") || res.data?.message || "Failed to fetch subscription."
      );
    }

    // API returns subscription info or `null` when none exist.
    return res.data ?? null;
  },
  {
    condition: (_, { getState }) => {
      const state = getState();
      const billingState = state?.billing;
      const token = state?.auth?.token;

      // If user isn't logged in, don't call /api/billing/subscription.
      if (!token) return false;

      if (!billingState) return true;
      return (
        billingState.status === "idle" ||
        billingState.status === "failed"
      );
    },
  }
);

const billingSlice = createSlice({
  name: "billing",
  initialState: {
    status: "idle", // idle | loading | succeeded | failed
    error: "",
    subscription: null,
  },
  reducers: {
    clearSubscription(state) {
      state.status = "idle";
      state.error = "";
      state.subscription = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentSubscription.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchCurrentSubscription.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = "";
        state.subscription = action.payload ?? null;
      })
      .addCase(fetchCurrentSubscription.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Failed to fetch subscription.";
        state.subscription = null;
      });
  },
});

export const { clearSubscription } = billingSlice.actions;
export default billingSlice.reducer;

